import ApplicationAdapter from '../application';

export default class Set extends ApplicationAdapter {
  namespace = 'schools/v4';

  pathForType(type) {
    type = type.replace(/^school-options\/set/, 'schema/optionsets');
    return type;
  }
}
